/* eslint-disable no-debugger */
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { FaUserAlt } from "react-icons/fa";
import { VscChromeClose } from "react-icons/vsc";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import LanguageDropdown from "../components/language_dropdown/LanguageDropdown";
import {
  checkGuestToken,
  isUserAuthenticated,
} from "../helpers/auth/authUtils";
import { logoutUser } from "../redux/rootActions";
import { TranslationComponentProps } from "../types/translationComponentProps";

interface IProps extends TranslationComponentProps {
  onClick: () => void;
  handleModal: () => void;
}

const ChatTitle: React.FC<IProps> = (props: IProps) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isAuthTokenValid = isUserAuthenticated();
  const isGuestTokenValid = checkGuestToken();

  const toggleMenu = () => {
    // Otvara meni samo ako je korisnik prijavljen kao gost ili autentifikovan
    if (isAuthTokenValid || isGuestTokenValid) {
      setIsMenuOpen(!isMenuOpen);
    }
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    setIsMenuOpen(false); // Zatvori meni
  };

  return (
    <div className="chat-title d-flex justify-content-between">
      <div className="chat-title-content">
        {/* Ikonica čikice */}
        <div
          className={`chat-title-icon ${
            isAuthTokenValid || isGuestTokenValid
              ? "chat-title-icon-active"
              : ""
          }`}
          onClick={toggleMenu}
        >
          <FaUserAlt
            className={`chat-user-icon ${
              isAuthTokenValid || isGuestTokenValid
                ? "chat-user-icon-active"
                : ""
            }`}
          />

          {/* Dropdown meni */}
          {isMenuOpen && (
            <div className="chat-dropdown-menu">
              {isAuthTokenValid || isGuestTokenValid ? (
                <Button onClick={handleLogout} className="chat-logout-button">
                  {props.t("LOGOUT.logout")}
                </Button>
              ) : (
                <span>{props.t("LOGOUT.not_logged_in")}</span>
              )}
            </div>
          )}
        </div>

        {/* Jezički dropdown */}
        <LanguageDropdown />

        {/* Naslov */}
        <div className="chat-title-container">
          <div className="chat-title-text">{props.t("title")}</div>
        </div>

        {/* Minimizacija */}
        <div className="chat-minimize-container">
          <Button className="title-btn" onClick={props.onClick}>
            <VscChromeClose />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ChatTitle);
